<template>
  <v-edit-dialog
    v-if="isEdit"
    :return-value.sync="updateValue"
    large
    @save="handleUpdate(updateValue)"
    @cancel="cancel"
    @open="open"
  >
    <slot></slot>
    <template v-slot:input>
      <div class="mt-4 subtitle">Actualizar</div>
      <v-text-field
        v-model="updateValue"
        label="Edit"
        single-line
        autofocus
        :prefix="prefix"
        :suffix="suffix"
        :hint="hint"
        :rules="rules"
      >
      </v-text-field>
    </template>
  </v-edit-dialog>
  <div v-else>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "UpdateField",
  props: {
    value: [String, Number],
    isEdit: { type: Boolean, default: false },
    cancel: { type: Function, default: () => {} },
    open: { type: Function, default: () => {} },
    rules: { type: Array, default: () => [] },
    prefix: { type: String, default: undefined },
    suffix: { type: String, default: undefined },
    hint: { type: String, default: undefined }
  },
  data() {
    return {
      updateValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.updateValue = newValue;
    }
  },
  methods: {
    handleUpdate(value) {
      this.$emit("updateProperty", value);
    }
  }
};
</script>

<style>
.v-text-field__prefix {
  color: rgba(0, 0, 0, 0.54);
}

.v-text-field__suffix {
  color: rgba(0, 0, 0, 0.54);
  font-size: 15px;
  letter-spacing: 0.4px;
}
</style>
